// eslint-disable-next-line import-x/no-internal-modules
import '#shared/lib/time/dayjsInit';
import { CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';

import {
  AuthProvider,
  IdleUXController,
  NotificationSnackbar,
  queryClient,
  SentryDebugPanel,
} from '#features';
import {
  isSentryDebugEnabled,
  NetworkStateProvider,
  ThemeConnector,
} from '#shared';

import '../muiInit';

import { AppRouter } from './router';

export const App = () => {
  const showSentryDebug = isSentryDebugEnabled();

  useEffect(() => {
    const initialLoader: HTMLDivElement | null =
      document.querySelector('#onInitLoader');
    if (initialLoader) {
      setTimeout(() => {
        initialLoader.style.display = 'none';
      }, 250);
    }
  }, []);

  return (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeConnector>
          <ReactQueryDevtools />
          <CssBaseline enableColorScheme />
          <IdleUXController />
          <NetworkStateProvider>
            <AppRouter />
          </NetworkStateProvider>
          <NotificationSnackbar />
          {showSentryDebug && <SentryDebugPanel />}
        </ThemeConnector>
      </QueryClientProvider>
    </AuthProvider>
  );
};
